import styles from './index.module.less';
import dynamic from 'next/dynamic';
const TopThree = dynamic(() => import('./cpns/TopThree'), {
  ssr: true,
});
const BottomOther = dynamic(() => import('./cpns/BottomOther'), {
  ssr: true,
});
import { useMemo } from 'react';
const Index = ({ data }: { data: any }) => {
  const topSet = new Set<string>([
    '/guide/how-to-report-impersonation-on-twitter',
    '/guide/quick-and-effective-google-dmca-takedown-guide',
    '/guide/how-to-report-a-fake-facebook-account',
  ]);
  const [topListThree, bottomListOther] = useMemo(() => {
    return [
      data.filter((item: any) => topSet.has(item.url_path)),
      data.filter((item: any) => !topSet.has(item.url_path)),
    ];
  }, [data]);
  return (
    <div className={styles.container}>
      <ul className={styles.brumer}>
        <li>
          <a href={process.env.NEXT_APP_WEB_HOST}>Home</a>
        </li>
        <li>{'>'}</li>
        <li>
          <a href={process.env.NEXT_APP_WEB_HOST + '/guide'}>Guides</a>
        </li>
      </ul>
      <h1>Protection Guide Hub</h1>
      <div className={styles.desc}>Protect your content across all platforms with our comprehensive guides</div>
      <TopThree list={topListThree} />
      <BottomOther data={bottomListOther} />
    </div>
  );
};

export default Index;
